import { render, staticRenderFns } from "./_algoliaSelect.vue?vue&type=template&id=4911d0d9&scoped=true"
import script from "./_algoliaSelect.vue?vue&type=script&lang=js"
export * from "./_algoliaSelect.vue?vue&type=script&lang=js"
import style0 from "./_algoliaSelect.vue?vue&type=style&index=0&id=4911d0d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4911d0d9",
  null
  
)

export default component.exports